<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-06-24 10:54:39
 * @Description: 电缆组件
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="position-absolute cable" :style="{ height: height, top: top }">
    <el-col class="h-100">
      <el-card shadow="never" class="cable_list">
        <div slot="header" class="clearfix business_dialog_title m-b-5">
          <span class="fz-14">电缆清单</span>
          <span class="iconfont icon-close r cur_pointer" @click="closeComponent"></span>
        </div>
        <div class="h-100">
          <el-row :gutter="10">
            <el-col :span="7">
              <el-input
                v-model="searchData.cableCode"
                @keyup.native.enter="searchFilterData"
                size="small"
                placeholder="电缆编号"
                clearable
              ></el-input>
            </el-col>
            <el-col :span="7">
              <el-input
                size="small"
                clearable
                @keyup.native.enter="searchFilterData"
                v-model="searchData.cableList"
                placeholder="清册名称"
              ></el-input>
            </el-col>
            <el-col :span="7">
              <el-select
                popper-class="document_select-popper"
                class="w-100"
                filterable
                size="small"
                clearable
                @change="searchFilterData"
                v-model="searchData.lifeCycleStatus"
                placeholder="敷设状态"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-tooltip effect="dark" content="搜索" placement="top" :open-delay="1000">
                <el-button
                  class="button-color"
                  type="primary"
                  @click="searchFilterData"
                  icon="iconfont icon-yxr-ss"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
          <div class="cable_list_table p-t-10">
            <el-table
              :data="tableData"
              border
              @sort-change="sortChange"
              height="100%"
              highlight-current-row
              @row-click="clickRow"
              ref="cableTable"
            >
              <el-table-column
                show-overflow-tooltip
                sortable="custom"
                label="清册名称"
                prop="cableList"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                sortable="custom"
                label="电缆编号"
                prop="cableCode"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                sortable="custom"
                label="敷设状态"
                prop="lifeCycleStatus"
              >
                <template slot-scope="scope">
                  {{
                    _.find(statusList, ['id', scope.row.lifeCycleStatus])
                      ? _.find(statusList, ['id', scope.row.lifeCycleStatus]).name
                      : ''
                  }}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="r">
            <el-pagination
              ref="cablePagination"
              background
              @current-change="changePageNo"
              :current-page.sync="pageNo"
              :page-size.sync="pageSize"
              :pager-count="5"
              layout="total, prev, pager, next"
              :total="pageTotal"
            ></el-pagination>
          </div>
        </div>
      </el-card>
      <el-card shadow="never" class="m-t-10 position-relative cable_detail">
        <div slot="header" class="clearfix m-b-5">
          <span class="fz-14">电缆信息</span>
          <el-tooltip placement="top" content="会议记录" :open-delay="1000">
            <el-button
              class="r button-color"
              :disabled="!((moduleAuth && moduleAuth.read) || currentEnv.DEBUG)"
              icon="iconfont icon-file"
              @click="showRecord"
            ></el-button>
          </el-tooltip>
        </div>
        <div class="cable-info" :class="isShowCheck ? 'h-90' : 'h-100'">
          <div>
            <div class="cable-info__list b-none d-flex flex-align-center">
              <p class="info-left">起点部件</p>
              <p class="p-l-10 p-r-10 flex-1">{{ rowData ? rowData.startComponent : '' }}</p>
              <span
                class="p-0 p-r-10 iconfont icon-localtion"
                v-show="rowData && rowData.startComponent"
                @click="findComponentInPlayer(rowData.sCode || '')"
              ></span>
            </div>
            <div class="cable-info__list d-flex flex-align-center b-none">
              <p class="info-left">终点部件</p>
              <p class="p-l-10 p-r-10 flex-1">{{ rowData ? rowData.endComponent : '' }}</p>
              <span
                class="p-r-10 iconfont icon-localtion"
                @click="findComponentInPlayer(rowData.eCode || '')"
                v-show="rowData && rowData.endComponent"
              ></span>
            </div>
            <div class="cable-info__list d-flex flex-align-center b-none">
              <p class="info-left">电缆编号</p>
              <p class="p-l-10 p-r-10 flex-1">{{ rowData ? rowData.cableCode : '' }}</p>
              <span
                class="p-r-10 iconfont icon-localtion"
                v-show="rowData && rowData.cableCode"
                @click="findComponentInPlayer(rowData.cableCode || '')"
              ></span>
            </div>
            <div class="cable-info__list d-flex flex-align-center b-none">
              <p class="info-left">电缆规格</p>
              <p class="p-l-10 p-r-10 flex-1">{{ rowData ? rowData.productType : '' }}</p>
            </div>
            <div class="cable-info__list d-flex flex-align-center b-none">
              <p class="info-left">参考长度</p>
              <p class="p-l-10 p-r-10 flex-1">{{ rowData ? rowData.referenceQty : '' }}</p>
            </div>
            <div class="cable-info__list d-flex flex-align-center">
              <p class="info-left">三维长度</p>
              <p class="p-l-10 p-r-10 flex-1">{{ rowData ? rowData.desQty : '' }}</p>
            </div>
          </div>
          <div class="m-t-20" :style="{ height: `${cardHeight / 4 - 25}px` }">
            <el-tabs v-model="activeName" type="card">
              <el-tab-pane name="academic" label="设计院路径">
                <template v-if="rowData && rowData.referenceCableRoute">
                  <p
                    class="hover-route f-12"
                    @click="centerToSelectRoute(item)"
                    v-for="(item, index) in rowData.referenceCableRoute.split(';')"
                    :key="index"
                  >
                    {{ item }}
                  </p>
                </template>
              </el-tab-pane>
              <el-tab-pane name="3d" label="三维敷设路径">
                <template v-if="rowData && rowData.desCableRoute">
                  <p
                    class="hover-route fz-12"
                    @click="centerToSelectRoute(item)"
                    v-for="(item, index) in rowData.desCableRoute.split(';')"
                    :key="index"
                  >
                    {{ item }}
                  </p>
                </template>
              </el-tab-pane>
            </el-tabs>
            <el-row class="bottom_btn" v-if="isShowCheck">
              <el-col :span="6">
                <el-button
                  :disabled="
                    !rowData ||
                      (rowData &&
                        rowData.lifeCycleStatus !== 1 &&
                        rowData.lifeCycleStatus !== 2 &&
                        rowData.lifeCycleStatus !== 4) ||
                      !((moduleAuth && moduleAuth.update) || currentEnv.DEBUG)
                  "
                  size="small"
                  type="success"
                  @click="openCheckDialog(1)"
                  >检查通过</el-button
                >
              </el-col>
              <el-col :span="6">
                <el-button
                  :disabled="
                    !rowData ||
                      (rowData &&
                        rowData.lifeCycleStatus !== 1 &&
                        rowData.lifeCycleStatus !== 2 &&
                        rowData.lifeCycleStatus !== 4) ||
                      !((moduleAuth && moduleAuth.update) || currentEnv.DEBUG)
                  "
                  type="danger"
                  size="small"
                  @click="openCheckDialog(0)"
                  >检查不通过</el-button
                >
              </el-col>
            </el-row>
          </div>
        </div>
      </el-card>
    </el-col>
    <el-dialog
      :close-on-click-modal="false"
      title="会议记录"
      :visible.sync="recordDialog"
      @close="recordTable = []"
      width="700px"
      :modal="false"
    >
      <el-table :data="recordTable" border stripe height="400px">
        <el-table-column label="序号" width="90px">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column label="会审结果" prop="result"></el-table-column>
        <el-table-column label="记录人" prop="createdUserName"></el-table-column>
        <el-table-column label="记录时间">
          <template slot-scope="scope">
            {{ moment(scope.row.createdTime).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="会审"
      :visible.sync="checkDialog"
      @close="checkForm.result = ''"
      width="40%"
      class="check-dialog"
    >
      <el-form size="small" :model="checkForm" ref="checkForm" label-width="90px" class="p-r-20">
        <el-form-item label="会审结果：" prop="result">
          <el-input
            type="textarea"
            :rows="3"
            v-model.trim="checkForm.result"
            :maxlength="35"
          ></el-input>
        </el-form-item>
        <el-form-item label="记录人：" prop="result">
          <span>{{ userInfo.name }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="checkDialog = false">取消</el-button>
        <el-button type="primary" @click="submitCheck" :loading="saveLoading">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FnMixins from '@/assets/js/fnMixins'
import ApiMixinCable from '@/assets/js/api/cableManagement'
import ApiMixinDictionaryManagement from '@/assets/js/api/dictionaryManagement'
import ApiMixinDocument from '@/assets/js/api/documents'
import ConfirmAuth from '@/assets/js/confirmAuth'

export default {
  name: 'CableList',
  mixins: [FnMixins, ApiMixinCable, ApiMixinDictionaryManagement, ApiMixinDocument],
  watch: {
    async $route(to) {
      if (this.$route.path.indexOf('/docView') > -1) {
        this.cableId = to.params.id
      }
    },
    // 监听切换模型
    loadedModel(loaded) {
      if (loaded) {
        // 模型加载完成
        this.drawCable()
        this.drawLine()
      }
    },
  },
  props: ['documentId', 'player', 'height', 'top', 'loadedModel'],
  async created() {
    this.moduleAuth = await ConfirmAuth('三维检查')
    this.isShowCheck = this.$route.query.showCheck ? this.$route.query.type === 'CableList' : false
    // 获取当前的电缆，定位当前点击的电缆
    if (this.$route.query.type === 'CableList' && !_.isEmpty(this.$route.query.requestParam)) {
      this.tableData = await this.initCableData(JSON.parse(this.$route.query.requestParam))
      this.$nextTick(() => {
        this.$refs.cablePagination.internalCurrentPage = JSON.parse(
          this.$route.query.requestParam
        ).pageNo
      })
    } else {
      this.tableData = await this.initCableData()
    }
    this.statusList = this.getDiscipline()
    if (this.tableData.length > 0) {
      if (this.$route.query.type === 'CableList') {
        this.rowData = this.tableData[this.$route.query.index]
        this.$refs.cableTable.setCurrentRow(this.tableData[this.$route.query.index])
      }
    }
    await this.routerInByCableList()
    // 定位到可视区域
    this.$nextTick(() => {
      const currentNode = document.getElementsByClassName('current-row')[0]
      if (currentNode) {
        this.$refs.cableTable.bodyWrapper.scrollTop = currentNode.offsetTop
      }
    })
  },
  data() {
    return {
      userInfo: Wiz.AuthHooks.GetUserInfo(),
      markerIdList: [], // 存储当前界面的marklist
      isShowCheck: true,
      cableModelList: [],
      selectionModel: '',
      saveLoading: false,
      checkDialog: false,
      checkForm: {
        isPass: 0,
        result: '',
      },
      activeName: 'academic',
      recordDialog: false,
      recordTable: [],
      moduleAuth: null,
      cableId: 'noCableId',
      pageNo: 1,
      pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 10,
      pageTotal: 0,
      rowData: null,
      tableData: [],
      statusList: [],
      searchData: {
        cableCode: '',
        cableList: '',
        lifeCycleStatus: '',
      },
      timeOut: null,
      listOrderBy: 'cableList', // 列表排序字段
      orderIsAsc: true, // 列表排序方式
      /**
       * 电缆绘制相关
       */
      sMarkedId: null,
      eMarkedId: null,
      cableImgId: null,
      taryLineId: null,
    }
  },
  computed: {
    cardHeight() {
      return `${window.innerHeight - 140}`
    },
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  methods: {
    closeComponent() {
      this.$emit('closeComponent', 'CableList')
    },
    /**
     * @description: 表格排序
     * @param {*} column
     * @return {*}
     */

    async sortChange(column) {
      if (column.column === null) {
        return
      }
      this.listOrderBy = column.prop
      if (column.order === 'ascending') {
        this.orderIsAsc = true
        this.tableData = await this.initCableData()
      } else {
        this.orderIsAsc = false
        this.tableData = await this.initCableData()
      }
    },
    /**
     * @description: 根据部件的id获取code
     * @param {*} id
     * @return {*}
     */

    async getTagCode(id) {
      const res = await this.apiCable({
        method: 'tag',
        params: {
          id,
          code: '',
          pageSize: 100000,
          pageNo: 1,
          siteId: this.currentProject.id,
        },
      })
      if (res && res.code === 0 && res.data && res.data.length) {
        return res.data[0].code
      }
      return null
    },
    // 点击定位
    findComponentInPlayer(tagCode) {
      this.$emit('currentCodeChange', tagCode)
    },
    // 提交审查
    async submitCheck() {
      this.saveLoading = true
      const params = {}
      _.assign(params, this.checkForm)
      params.cableId = this.rowData.id
      params.createdTime = moment().format('YYYY-MM-DD HH:mm:ss')
      params.createdUser = this.userInfo.sub
      params.LastModifiedUser = this.userInfo.sub
      const result = await this.apiCable({ method: 'check', params })
      this.saveLoading = false
      if (result && result.code === 0) {
        const obj = {}
        _.assign(obj, this.rowData)
        obj.siteId = this.currentProject.id
        obj.lifeCycleStatus = this.checkForm.isPass === 0 ? 4 : 3
        const res = await this.apiCable({ method: 'edit', params: obj })
        if (res && res.code === 0 && res.data) {
          this.$message.success(res.msg)
          _.assign(this.rowData, res.data)
          this.checkDialog = false
          this.tableData = await this.initData()
          this.$refs.cableTable.setCurrentRow(_.find(this.tableData, { id: this.rowData.id }))
        }
      }
    },
    // 打开审批模态框
    openCheckDialog(isPass) {
      this.checkForm.isPass = isPass
      this.checkDialog = true
    },
    // 查看会议记录
    async showRecord() {
      if (this.rowData && this.rowData.id) {
        this.recordDialog = true
        const res = await this.apiCable({ method: 'record', params: { id: this.rowData.id } })
        if (res && res.code === 0 && res.data) {
          this.recordTable = res.data
        } else {
          this.recordTable = []
        }
      } else {
        this.$message.info('请先选择电缆')
        this.recordTable = []
      }
    },
    // 如果是从电缆清单点击过来
    async routerInByCableList() {
      if (this.cableId !== 'noCableId') {
        if ((this.moduleAuth && this.moduleAuth.read) || currentEnv.DEBUG) {
          this.rowData = this.tableData[0]
          this.$refs.cableTable.setCurrentRow(this.tableData[0])
          this.$nextTick(() => {
            if (this.$refs.cableTable) {
              this.$refs.cableTable.setCurrentRow(this.rowData)
            }
          })
          if (this.cableModelList.length) {
            this.$set(this.rowData, 'sCode', await this.getTagCode(this.rowData.startEquipment))
            this.$set(this.rowData, 'eCode', await this.getTagCode(this.rowData.endEquipment))
          }
          // 传值到模型
          this.$emit('setCableData', this.rowData)
        } else {
          this.rowData = null
          this.cableModelList = []
          // 传值到模型
          this.$emit('setCableData', this.rowData)
        }
      }
    },
    // 电缆列表
    async initCableData(params = {}) {
      if ((this.moduleAuth && this.moduleAuth.read) || currentEnv.DEBUG) {
        this.listLoading = true
        params = _.isEmpty(params)
          ? {
              cableCode: { $txet: this.searchData.cableCode },
              cableList: { $txet: this.searchData.cableList },
              lifeCycleStatus: this.searchData.lifeCycleStatus,
              siteId: this.currentProject.id,
              pageSize: this.pageSize,
              pageNo: this.pageNo,
              status: 0,
            }
          : params
        if (this.cableId !== 'noCableId' && !this.clickButton) {
          params.id = this.cableId
        }
        if (this.listOrderBy) {
          params.sort = `${this.listOrderBy}:${this.orderIsAsc ? 'asc' : 'desc'}`
        }
        const res = await this.apiCable({
          method: 'list',
          params,
        })
        this.listLoading = false
        if (res && res.code === 0 && res.data) {
          this.pageTotal = res.page && res.page.recordCount > 0 ? res.page.recordCount : 0
          return res.data
        }
        this.pageTotal = 0
        return []
      }
      return []
    },
    // 分页
    async changePageNo(page) {
      this.pageNo = page
      this.tableData = await this.initCableData()
      if (this.$refs.cableTable) {
        if (this.rowData) {
          const data = _.find(this.tableData, { id: this.rowData.id })
          if (data) {
            _.assign(this.rowData, data)
            this.$refs.cableTable.setCurrentRow(data)
            this.$set(this.rowData, 'sCode', await this.getTagCode(this.rowData.startEquipment))
            this.$set(this.rowData, 'eCode', await this.getTagCode(this.rowData.endEquipment))
          }
        }
      }
    },

    // 单击表格中的某一行数据
    async clickRow(row) {
      // 判断模型是否加载完全
      if (!this.player) {
        this.$message.warning('模型还未加载完全，请稍候再试~')
        this.$refs.cableTable.setCurrentRow(this.rowData)
        return
      }
      if (this.timeOut) clearTimeout(this.timeOut)
      this.timeOut = setTimeout(async () => {
        this.rowData = row
        this.$refs.cableTable.setCurrentRow(row)
        this.$set(this.rowData, 'sCode', await this.getTagCode(this.rowData.startEquipment))
        this.$set(this.rowData, 'eCode', await this.getTagCode(this.rowData.endEquipment))
        // 绘制电缆
        this.drawCable()
        this.drawLine()
      }, 800)
    },
    /**
     * @description: 绘制电缆
     * @param {*}
     * @return {*}
     */

    async drawCable() {
      if (_.isNil(this.rowData)) {
        // 去除面板
        const markerList = await PlayerUtils.call(this.player.Native.GisMarker.getMarkerList)
        _.forEach(markerList, (el) => {
          if (this.markerIdList.includes(el.id)) {
            this.player.Native.GisMarker.destroy(el.id)
          }
        })
        this.sMarkedId = null
        this.eMarkedId = null
        this.markerIdList = []
        // 取消选中态
        this.player.Native.ModelTree.setSelectItem(0)
        return
      }
      // 清除之前所有的颜色
      await PlayerUtils.call(this.player.Native.ModelTree.restoreAllItemColor)
      // 设置面板text值
      this.player.Native.ModelTree.setItemColor([this.rowData.sCode], 0xff0000ff)
      this.player.Native.ModelTree.setItemColor([this.rowData.eCode], 0x0000ffff)
      const eText = `\n${this.rowData.cableCode}\n\n终点设备：${this.rowData.endComponent}\n`
      const sText = `\n${this.rowData.cableCode}\n\n起点设备：${this.rowData.startComponent}\n`
      const sPos = [] // 起点定位点
      const ePos = [] // 终点定位点
      const count = 0
      // 1.加载图片
      if (!this.cableImgId) {
        this.cableImgId = await PlayerUtils.call(
          this.player.Native.GisMarker.loadImage,
          'rgba:174, 165, 224, 255'
        )
      }
      // 2.获取父容器坐标点/*  */
      const resStart = await PlayerUtils.call(
        this.player.Native.ModelTree.calcItemAabb,
        this.rowData.sCode
      )
      // 面板定位在包围盒的左前上方
      if (!_.isEmpty(resStart)) {
        sPos[0] = resStart.localAabb.min[0] // x坐标
        sPos[1] = resStart.localAabb.min[1] // y坐标
        sPos[2] = resStart.localAabb.max[2] // z坐标
        if (this.sMarkedId) {
          this.player.Native.GisMarker.update(this.sMarkedId, {
            text: sText,
            pos: sPos,
            imgId: this.cableImgId,
          })
        } else {
          this.drawPanel(sPos, sText, 'start')
        }
      }
      const resEnd = await PlayerUtils.call(
        this.player.Native.ModelTree.calcItemAabb,
        this.rowData.eCode
      )
      // 面板定位在包围盒的左前上方
      if (!_.isEmpty(resEnd)) {
        ePos[0] = resEnd.localAabb.min[0] // x坐标
        ePos[1] = resEnd.localAabb.min[1] // y坐标
        ePos[2] = resEnd.localAabb.max[2] // z坐标
        if (this.eMarkedId) {
          this.player.Native.GisMarker.update(this.eMarkedId, {
            text: eText,
            pos: ePos,
            imgId: this.cableImgId,
          })
        } else {
          this.drawPanel(ePos, eText, 'end')
        }
      }
      // 去除多余的面板
      const markerList = await PlayerUtils.call(this.player.Native.GisMarker.getMarkerList)
      _.forEach(markerList, (el, index) => {
        if (
          el.id !== this.sMarkedId &&
          el.id !== this.eMarkedId &&
          this.markerIdList.includes(el.id)
        ) {
          this.player.Native.GisMarker.destroy(el.id)
        }
      })
    },
    /**
     * @description: 绘制面板
     * @param {*} pos 面板所在的位置
     * @param {*} text 面板的内容
     * @param {*} stauts 起点or终点
     * @return {*}
     */

    drawPanel(pos, text, stauts) {
      const option = {
        pos, // 定位点，世界坐标，三维向量
        visible: true, // 显示隐藏状态
        size: [250, 90], // 整体尺寸，二维向量，-1表示不限制，自动大小
        nodeOffset: [0, 0], // 相对定位点的偏移量，二维向量
        imgId: this.cableImgId, // 图片
        imgSize: [250, 90], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
        imgOffset: [0, 0], // 图片相对标记的偏移量
        text, // 文本
        fontSize: 14.0, // 字体大小
        breakWidth: 250, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
        textOffset: [0, 0], // 文字相对标记的偏移量
        textColor: 0xffffffff, // 文本颜色
        title: '', // 标题
        titleFontSize: 18.0, // 标题文字大小
        titleColor: 0xffffffff, // 标题颜色
        userData: null, // 用户数据，仅帮外部系统保存数据
      }
      // option里面的类容均为可选，但是option至少是{}，不能为null
      this.player.Native.GisMarker.create(option, (markerId) => {
        if (stauts === 'start') {
          this.sMarkedId = markerId
        } else {
          this.eMarkedId = markerId
        }
        this.markerIdList.push(markerId)
      })
    },
    /**
     * @description: 创建电缆点的连线
     * @param {*}
     * @return {*}
     */

    async drawLine() {
      if (_.isNil(this.rowData)) {
        // 判断是否已有线路
        if (this.taryLineId) {
          await PlayerUtils.call(this.player.Native.PathMgr.deletePath, this.taryLineId)
          this.taryLineId = null
        }
        return
      }
      const modelInfo = await PlayerUtils.call(this.player.Native.Model.getInfo, this.documentId)
      const modelAllInfo = await PlayerUtils.call(this.player.Native.Model.getAllInfo)
      // 判断是否已有线路
      if (this.taryLineId) {
        await PlayerUtils.call(this.player.Native.PathMgr.deletePath, this.taryLineId)
        this.taryLineId = null
      }
      // 获取电缆编号
      const taryCode = this.rowData.cableCode
      // 根据code获取点
      const instancePath = await PlayerUtils.call(
        this.player.Native.Model.getInstancePathByCode,
        this.documentId,
        taryCode
      )
      // 绘制线路的id
      this.taryLineId = await PlayerUtils.call(
        this.player.Native.PathMgr.createPath,
        modelInfo.nodePtr
      )
      // 设置线的颜色
      await PlayerUtils.call(this.player.Native.PathMgr.setDefaultLineColor, 0xff0000ff)
      // 添加点
      await PlayerUtils.call(
        this.player.Native.PathMgr.addPathPoints,
        this.taryLineId,
        instancePath
      )
      // 设置线的粗细
      await PlayerUtils.call(this.player.Native.PathMgr.setPathWidth, this.taryLineId, 3)
      // 通知路径应用修改
      PlayerUtils.call(this.player.Native.PathMgr.submitPathChange, this.taryLineId)
      // 电缆经过的桥架变色
      this.player.Native.Settings.set('color.pickup.bkAlpha', 'float', '1.0')
      const cableTrayList = this.rowData.cableTray.split(';')
      this.player.Native.ModelTree.setItemColor(cableTrayList, 0x00ff00ff)
      // 定位到电缆
      this.$emit('currentCodeChange', this.rowData.cableCode)
      setTimeout(() => {
        this.player.Native.Settings.set('color.pickup.bkAlpha', 'float', '0.5')
      }, 2000)
    },
    /**
     * @description: 电缆列表搜索
     * @param {*}
     * @return {*}
     */

    async searchFilterData() {
      this.rowData = null
      // 传值到模型
      this.$emit('setCableData', this.rowData)
      this.clickButton = true
      this.pageNo = 1
      this.tableData = await this.initCableData()
    },
  },
  async beforeDestroy() {
    clearTimeout(this.timeOut)
    this.rowData = null
    await this.drawCable()
    await this.drawLine()
    this.player.Native.ModelTree.restoreAllItemColor()
  },
}
</script>
<style lang="scss">

@import '../../css/select.scss';

</style>
<style lang="scss" scoped>

@import '../../css/index.scss';
.cable {
  width: 368px;
  top: 76px;
  right: 35px;
  padding: 10px;
  border-radius: 4px;
  z-index: 99;
  background-color: rgba(46, 107, 176, 0.5) !important;
  &_list {
    height: calc(45% - 6px);
    border: none !important;
    &_table {
      height: calc(100% - 65px);
    }
  }
  &_detail {
    height: calc(55% - 5px);
  }
}
.select-model {
  margin-left: 50px;
}
.control-icon {
  cursor: pointer;
  margin: 5px;
  font-size: 16px;
}
.cable-info {
  margin: 0 !important;
  overflow: auto;
  background-color: rgba(24, 41, 72, 0.5) !important;
  &__list {
    border: none;
    font-size: 12px;
    color: #fff;
    .info-left {
      width: 30%;
      display: inline-block;
      padding: 4px 20px;
      border-right: none;
    }
    span {
      cursor: pointer;
      color: #409eff;
    }
  }
  .b-none {
    border-bottom: none;
  }
}
/deep/ .el-card__body {
  padding: 0 !important;
  margin: 0 !important;
  height: 92%;
  tr.current-row > td {
    background-color: #e8e882;
  }
  tr.el-table__row--striped.current-row td {
    background-color: #e8e882 !important;
  }
}
.bottom_btn {
  position: absolute;
  left: -10px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  bottom: 2px;
  padding: 0px 60px;
  /deep/ .el-button.is-disabled {
    color: #586781 !important;
    background-color: rgba(192, 196, 204, 0.7) !important;
    border: none;
  }
  /deep/.el-button--small {
    padding: 6px !important;
    font-size: 14px !important;
  }
  /deep/.el-button--success {
    background-color: rgba(0, 192, 255, 0.8);
  }
  /deep/.el-button--danger:focus,
  .el-button--danger:hover {
    background-color: rgba(255, 95, 95, 0.8);
  }
}
.hover-route {
  padding-top: 14px;
  color: #fff;
}
.button-color {
  border: none;
  color: #fff;
  background-color: #00c0ff !important;
}
.h-90 {
  height: 90%;
}

</style>
